import DefaultDashboardContainer from "../../Componant/Dashboard/DefaultDashboard/index";

const DefaultDashboard = () => {
  return (
    <div className="page-body">
      <DefaultDashboardContainer />
    </div>
  );
};

export default DefaultDashboard;
